import type { authorityType } from '@/stores/user/type';
import { useAccountStore } from '@/stores/user';

export enum modeType {
  AND = 'and',
  OR = 'or'
};
export interface checkConfig {
  /* 为true可跳过验证（如：不登录也可显示fork） */
  skip?: boolean;
  /* 判断模式，默认为或 */
  mode?: modeType;
}

const defaultConfig = {
  skip: false,
  mode: modeType.OR
};

/**
 * 检查权限是否存在
 * authority 准入权限
 * checkConfig 配置
 */
export function checkAuth(authority: authorityType, config: checkConfig = defaultConfig) {
  const currentConfig = {
    ...defaultConfig,
    ...config
  };
  if (currentConfig?.skip) {
    return true;
  }

  const accountStore = useAccountStore();
  const currentAccess = accountStore.access;

  // 将用户权限转换为数组（如果它本身不是数组的话）
  const userPermissionList = Array.isArray(authority) ? authority : [authority];
  // 遍历用户权限列表
  for (const userPermission of userPermissionList) {
    const [userScope, userAction] = userPermission.split(':');

    // 标记是否找到匹配的权限
    let foundMatch = false; // 且模式

    for (const accessItem of currentAccess) {
      const scope = accessItem.scope;
      const actions = accessItem.actions;
      // 检查作用域是否匹配
      if (scope === userScope) {
        // 遍历当前作用域的动作列表
        for (const actionItem of actions) {
          if (actionItem.action === userAction) {
            if (currentConfig?.mode === modeType.OR) { // 或模式（满足一个即验证通过）
              return true;
            } else {
              foundMatch = true; // 且模式（全部满足才能验证通过）
              break;
            }
          }
        }
      }
    }

    if (!foundMatch && currentConfig?.mode === modeType.AND) { // 且模式
      return false;
    }
  }
  return false;
}

/**
 * 检查企业权限是否存在
 * authority 准入权限
 * checkConfig 配置
 */
export function checkEnterpriseAuth(authority: authorityType, config: checkConfig = defaultConfig) {
  const currentConfig = {
    ...defaultConfig,
    ...config
  };
  if (currentConfig?.skip) {
    return true;
  }

  const accountStore = useAccountStore();
  const currentAccess = accountStore.enterpriseAccess;

  // 将用户权限转换为数组（如果它本身不是数组的话）
  const userPermissionList = Array.isArray(authority) ? authority : [authority];
  // 遍历用户权限列表
  for (const userPermission of userPermissionList) {
    const [userScope, userAction] = userPermission.split(':');

    // 标记是否找到匹配的权限
    let foundMatch = false; // 且模式

    for (const accessItem of currentAccess) {
      const scope = accessItem.scope;
      const actions = accessItem.actions;
      // 检查作用域是否匹配
      if (scope === userScope) {
        // 遍历当前作用域的动作列表
        for (const actionItem of actions) {
          if (actionItem.action === userAction) {
            if (currentConfig?.mode === modeType.OR) { // 或模式（满足一个即验证通过）
              return true;
            } else {
              foundMatch = true; // 且模式（全部满足才能验证通过）
              break;
            }
          }
        }
      }
    }

    if (!foundMatch && currentConfig?.mode === modeType.AND) { // 且模式
      return false;
    }
  }
  return false;
}

/* 可信开源登录策略 */
// 需要判断界面是否被iframe嵌套，并且还需要判断界面的参数中是否含有be_nested=1
export function isTrustedSourceLogin() {
  const isIframed = window !== window.top;
  const trustedSourceLogin = window.location.search.includes('be_nested=1');
  return isIframed && trustedSourceLogin;
}

